var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSettingsHandlers } from '@/presentation/providers/settings-handlers-provider';
import { getContainerHeight } from '@/presentation/common-utils/common-utils';
import { Box, Button, ColumnLayout, Container, Header, SpaceBetween } from '@cloudscape-design/components-themed/components';
import { PATH_SETTINGS } from '@/presentation/common-utils/constants';
import { useNavigate } from 'react-router-dom';
import CodeEditor from "@/presentation/components/code-editor/code-editor";
import { useIsMounted } from '@/presentation/hooks';
const TABBED_CONTENT_PADDINGS = 60;
const ActionMetadataOverrides = () => {
    const [loading, setLoading] = useState(true);
    const [metadataValue, setMetadataValue] = useState('{}');
    const [providerName, setProviderName] = useState('-');
    const [editorHeight, setEditorHeight] = useState(400);
    const [currentRef, setCurrentRef] = useState(null);
    const ref = React.useRef(null);
    const { settings } = useSettingsHandlers();
    const settingsHandler = settings;
    const navigate = useNavigate();
    const isMounted = useIsMounted();
    useEffect(() => {
        if (isMounted.current) {
            setCurrentRef(ref === null || ref === void 0 ? void 0 : ref.current);
        }
    }, [ref === null || ref === void 0 ? void 0 : ref.current]);
    useEffect(() => {
        // The DOM element is accessible here.
        if (currentRef) {
            getContainerHeight('settingsActionMetadataOverridesEditor', setEditorHeight, editorHeight);
        }
    }, [currentRef]);
    useEffect(() => {
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            try {
                const actionMetadata = yield settingsHandler.listActionMetadataOverrides();
                if (!isMounted.current)
                    return;
                const { metadata } = ((_a = actionMetadata === null || actionMetadata === void 0 ? void 0 : actionMetadata.ActionMetadataOverrides) === null || _a === void 0 ? void 0 : _a[0]) || {};
                setMetadataValue(metadata ? JSON.stringify(metadata, null, 2) : '{}');
                if (metadata && Object.keys(metadata).length > 0) {
                    const providerNames = Object.keys(metadata).join(', ');
                    setProviderName(providerNames);
                }
            }
            catch (e) {
                console.error(e);
            }
            finally {
                if (isMounted.current)
                    setLoading(false);
            }
        });
        fetchData();
    }, []);
    return React.createElement(Container, { header: React.createElement(Header, { variant: "h2", actions: React.createElement(SpaceBetween, { direction: "horizontal", size: "l" },
                React.createElement(Button, { onClick: () => {
                        navigate(PATH_SETTINGS.ACTION_METADATA_OVERRIDES + '/edit');
                    } }, "Edit")) }, "Action Metadata Overrides") },
        React.createElement(SpaceBetween, { direction: "vertical", size: "l" },
            React.createElement(Box, null,
                React.createElement(Box, { variant: "awsui-key-label" }, "Provider"),
                React.createElement(Box, null, providerName)),
            React.createElement(ColumnLayout, { columns: 1, variant: "text-grid" },
                React.createElement("div", { ref: ref, id: "settingsActionMetadataOverridesEditor" },
                    React.createElement(CodeEditor, { loading: loading, code: metadataValue, height: editorHeight - TABBED_CONTENT_PADDINGS, heightType: 'px', readOnly: true, language: 'json' })))));
};
export default ActionMetadataOverrides;
